import '.bq{height:44px;}.ssr-plugin'
import '.ja{padding:4px 4px 4px 8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.u{position:absolute;}.ssr-plugin'
import '.jb{right:4px;}.ssr-plugin'
import '.jc{top:4px;}.ssr-plugin'
import { styled } from 'inlines'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { prettyNumber } from '@based/pretty-number'
import { Media } from '../Media/index.js'
import { Separator } from '../Separator/index.js'
import { IconButton } from '../IconButton/index.js'
import { useState } from 'react'

const shortenTheString = (str: string) => {
  return str.length > 60
    ? str.substring(0, 54) + '...' + str.substring(str.length - 4)
    : str
}

type FileItem = {
  preview: string
  name: string
  size: number
  progress?: number
  type?: 'file' | 'audio' | 'code' | 'video' | 'image' | 'color'
}

type FilePreviewItemProps = {
  file?: [string, FileItem]
  src: string
  idx?: number
  onRemove?: (idx: number) => void
}

export const FilePreviewItem = ({
  file,
  src,
  onRemove,
  idx,
}: FilePreviewItemProps) => {
  const [hover, setHover] = useState(false)

  const type = file?.[1]?.type
    ? (file[1].type
        .substring(0, file[1].type.lastIndexOf('/'))
        .toLowerCase() as FileItem['type'])
    : null

  return (
    <styled.div className="bq ja d d2 a s"
      style={{
        borderRadius: radius[12],
        '&:hover': {
          background: colors.neutral10Adjusted,
        },
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Media size="small" src={src || file?.[1]?.preview} type={type} />
      <Text variant="display-medium" color="neutral80">
        {shortenTheString(src || file?.[1]?.name || 'Unknown file')}
      </Text>
      {file?.[1]?.size && (
        <>
          <Separator variant="dot" />
          <Text variant="display-regular" color="neutral60">
            {prettyNumber(file[1].size, 'number-bytes')}{' '}
          </Text>
        </>
      )}
      {!src && file?.[1] && (
        <>
          <Separator variant="dot" />
          <Text variant="display-regular" color="neutral60">
            {file[1].progress === 100
              ? 'done'
              : file[1].progress
                ? file[1].progress + '%'
                : '0%'}
          </Text>
        </>
      )}
      {hover && (
        <div className="u jb jc">
          <IconButton
            icon="remove"
            tooltip="Remove"
            onClick={() => onRemove?.(idx)}
          />
        </div>
      )}
    </styled.div>
  )
}
